import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';
import {
  CreateProviderConfigRequest,
  ProviderConfig,
  UpdateProviderConfigRequest,
} from '../models/provider.model';

/** Feed (provider config) CRUD — /api/v1/admin/feeds. Super-admin only. */
@Injectable({ providedIn: 'root' })
export class ProviderConfigService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly feedsUrl = `${this.coreApiUrl}/api/v1/admin/feeds`;

  /** Every feed across tenants, optionally narrowed to one provider. */
  getAll(providerId?: string): Observable<ApiResponse<ProviderConfig[]>> {
    const params = providerId ? new HttpParams().set('providerId', providerId) : undefined;
    return this.http.get<ApiResponse<ProviderConfig[]>>(this.feedsUrl, { params });
  }

  get(id: string): Observable<ApiResponse<ProviderConfig>> {
    return this.http.get<ApiResponse<ProviderConfig>>(`${this.feedsUrl}/${id}`);
  }

  create(req: CreateProviderConfigRequest): Observable<ApiResponse<ProviderConfig>> {
    return this.http.post<ApiResponse<ProviderConfig>>(this.feedsUrl, req);
  }

  update(id: string, req: UpdateProviderConfigRequest): Observable<ApiResponse<ProviderConfig>> {
    return this.http.put<ApiResponse<ProviderConfig>>(`${this.feedsUrl}/${id}`, req);
  }

  delete(id: string): Observable<ApiResponse<null>> {
    return this.http.delete<ApiResponse<null>>(`${this.feedsUrl}/${id}`);
  }
}
